import {
  getBrandConfigForSubdomain,
  type BrandConfig,
  type BrandKey,
  isBrandKey,
} from "./config";
import { getBrandOverride } from "./debug";

/**
 * Detects the current subdomain
 */
export function detectSubdomain(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  return parts.length > 2 ? parts[0] : null;
}

/**
 * Gets the effective brand key, prioritizing debug override over subdomain
 * Returns a validated BrandKey or null
 */
export function getEffectiveBrandKey(): BrandKey {
  // Check for debug override first
  const debugOverride = getBrandOverride();
  if (debugOverride && isBrandKey(debugOverride)) {
    return debugOverride;
  }

  // Fall back to subdomain detection
  const subdomain = detectSubdomain();
  return isBrandKey(subdomain) ? subdomain : null;
}

/**
 * Gets the current brand configuration (always returns a complete config)
 */
export function getCurrentBrandConfig(): BrandConfig {
  const brandKey = getEffectiveBrandKey();
  return getBrandConfigForSubdomain(brandKey);
}

/**
 * Gets the support link for the current brand
 */
export function getSupportLink(): string {
  return getCurrentBrandConfig().supportLink;
}

/**
 * Gets the terms URL for the current brand
 */
export function getTermsUrl(): string {
  return getCurrentBrandConfig().termsUrl;
}

/**
 * Gets the brand name for the current brand
 */
export function getBrandName(): string {
  return getCurrentBrandConfig().brandName;
}

/**
 * Gets the CSS class name for the current brand
 */
export function getBrandClassName(): string {
  return getCurrentBrandConfig().className;
}

/**
 * Gets the logo URL for the current brand
 */
export function getLogoUrl(): string | undefined {
  return getCurrentBrandConfig().logoUrl;
}
